import Vue from 'vue'
import apis from '@/api'

const uploadFile = (data) => {
  let formData = new FormData()
  console.log(data)
  formData.append('file', data.file, data.file.name)
  formData.append('uploadId', data.file.uid)
  return new Promise((resolve, reject) => {
    const request = { ...apis.FORM_UPLOAD_CONFIG_API }
    request.params = formData
    Vue.prototype.$upload(request).asyncThen((resp) => {
      const params = Vue.prototype.$base64.encode(JSON.stringify({
        xdaptenantid: resp.data.tenantId,
        xdaptoken: Vue.prototype.$axios.defaults.headers.xdaptoken
      }))
      resolve(`${resp.data.url}&token=${params}`)
    }, (err) => {
      reject(err)
    }).asyncErrorCatch((err) => {
      reject(err)
    })
  })
}
export default {
  editorConfigType: 'STATIC_IMG_DEFAULT',
  componentName: 'FormConfigStatcImgDefault',
  configProperty: 'staticDefaultValue',
  extras: {
    uploadFile: uploadFile
  }
}
